module.exports = __webpack_public_path__ + "static/media/akins.a1385bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/akins.jpg
// module id = 246
// module chunks = 0